import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import walletIcon from '../../img/icons/wallet.svg';
import style from '../../style/components/signin/TwoFA.module.scss';

const OldWallet2FA = ({ handleSetup }) => {
  const { t } = useTranslation();

  const top = (
    <div className={style.row}>
      <div className={style.imgWrapper}>
        <img alt="wallet" src={walletIcon} className={style.oldWallet} />
      </div>
      <div>
        <h5>{t('multiFactor.oldWallet.title')}</h5>
        <p className={style.error}>
          {t('multiFactor.oldWallet.description_decommissioned')}
        </p>
      </div>
    </div>
  );

  const bottom = (
    <div className={style.alert}>
      <p>
        <Trans
          i18nKey="multiFactor.oldWallet.description_download"
          components={{ strong: <strong /> }}
        />
      </p>
      <div className={style.buttonWrapper}>
        <idme-button
          variant="secondary"
          size="small"
          text="Set Up"
          onClick={handleSetup}
        />
      </div>
    </div>
  );

  return (
    <Fragment>
      <div className={style.deprecated}>
        {top}
        {bottom}
      </div>
    </Fragment>
  );
};

OldWallet2FA.propTypes = {
  handleSetup: PropTypes.func.isRequired,
};

export default OldWallet2FA;
